// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import Bulgaria from '../_raw/flag/icon_flag_bulgaria.png';

export default () => <img src={Bulgaria} alt="Bulgaria" />;
